export default {"src":"/_next/static/media/remove.c73feffc.svg","height":20,"width":20};